var $search_filter_nav = $('[data-object="search-filter-nav"]'),
  $canvas = $('#search-form'),
  $filter_controls = $('#search-tab-bar-filter-controls'),
  $tab_bar_controls = $('#search-tab-bar-controls'),
  hideFilterControls = function () {
      $filter_controls.attr('aria-hidden', 'true');
      $tab_bar_controls.attr('aria-hidden', 'false');
  },
  hideOpenTips = function () {
      $.each($(".usajobs-search-tip[aria-hidden=false]"), function () {
          $(this).css({ "display": "none" }).attr("aria-hidden", "true");
      });
  };

$search_filter_nav.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="search-nav-bar"]'),
      behavior = $el.attr('data-behavior'),
      $target = $(document).find('#' + $el.attr('aria-controls')),
      state = $target.attr('aria-hidden');

    $el.blur(); // Removes focus
    hideOpenTips();

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^search-filter-nav/)) {
            $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
        }
    });
});

$search_filter_nav.on('search-filter-nav.close', function (event, opts) {
    event.preventDefault();
    opts.target.attr('aria-hidden', 'true');
    $('#search-tab-bar-filter').attr('aria-expanded', 'false');
    $canvas.removeAttr('data-state');
    hideFilterControls();
});

$search_filter_nav.on('search-filter-nav.close-refiner', function (event, opts) {
    var panel = opts.el.attr('data-parent-panel'),
      $parent = $('#' + panel),
      $trigger = opts.target.siblings('[aria-expanded=true]');

    event.preventDefault();

    opts.target.attr('aria-hidden', 'true');
    $parent.attr('aria-hidden', 'false');
    $trigger.attr('aria-expanded', 'false');
});

// Both of the data-objects, search-filter and search-pills, are handled in this file
// because they are so closely coupled.

var $search_filter = $('[data-object="search-filter"]'),
  $search_pills = $("[data-object='search-pills']"),
  $filter_count = $('#search-tab-bar-filter-count'),
  filter_count = 0,
  closeFilters = function () {
      var $filters = $('#search-tab-bar-controls [data-behavior="search-tab-bar.toggle-filters"]');

      $filters.trigger('click');
  },
  decrementCount = function () {
      filter_count = filter_count - 1;

      if (filter_count < 0) {
          filter_count = 0;
      }

      if (filter_count === 0) {
          $filter_count.parent().attr('aria-hidden', 'true');
      } else {
          $filter_count.text(filter_count);
      }
  },
  incrementCount = function () {
      filter_count = filter_count + 1;
      $filter_count.text(filter_count);
      $filter_count.parent().attr('aria-hidden', 'false');
  },
  updateDrawerFace = function (elem, force) {
      var $trigger = $(elem.attr('data-filter-trigger')),
        $siblings = $(elem).closest('ul').find('[data-behavior="search-filter.update"]'),
        has_selections = false;

      if (force === true) {
          has_selections = true;
      } else {
          $.each($siblings, function (idx, sibling) {
              if ($(sibling).prop('checked') === true) {
                  has_selections = true;
              }
          });
      }

      if (has_selections) {
          $trigger.addClass('has-selections');
      } else {
          $trigger.removeClass('has-selections');
      }
  };

$(document).ready(function () {
    // bindTooltips();
});

$search_filter.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="search-filter"]'),
      behavior = $el.attr('data-behavior');

    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^search-filter\./)) {
            $el.trigger(action, { el: $el, object: $object });
        }
    });
});

$search_pills.on("click", "[data-behavior]", function (event) {
    var $el = $(this),
        $object = $el.closest("[data-object='search-pills']"),
        behavior = $el.attr("data-behavior");

    $el.blur();

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^search-pills/)) {
            $el.trigger(action, { el: $el, object: $object });
        }
    });
});

$search_pills.on("keypress", "[data-behavior]", function (event) {
    if (event.keyCode == 13) {
        $(this).click();
    }
});

$search_filter.on('search-filter.jump-to-top', function (event, opts) {
    const $target = $(opts.el.attr('data-href')),
        $container = $(opts.el.attr('data-target')),
        focusable = $container[0].querySelectorAll('button, [href], input, [tabindex="0"], [tabindex="-1"]');

    event.preventDefault();

    $container.animate({
        scrollTop: 0
    }, 500, function () {
        $('html, body').animate({
            scrollTop: $target.offset().top
        });
        focusable[0].focus();
    });
});

$search_filter.on('search-filter.see-more', function (event, opts) {
    var $target = $search_filter.parent().find(opts.el.attr('data-target'));

    $('html, body').animate({
        scrollTop: $target.offset().top
    }, 500, function () {
        $target.trigger('click');
    });
});

$search_filter.on('search-filter.show-more', function (event, opts) {
    event.preventDefault();

    opts.el.parent().siblings('[aria-hidden=true]').removeAttr('aria-hidden');
    opts.el.parent().remove();
});

$search_filter.on('search-filter.accordion-expand', function (event, opts) {
    var refiner = opts.el.attr('aria-controls');
    if (refiner == "filter-agencies") {
        document.getElementById("department-agency-filter").focus();
    } else {
        document.getElementById("series-filter").focus();
    };
});

function checkForDismissedSearchAlerts() {
    if (!Basil.localStorage.isSet("dismissedSearchAlerts")) {
        Basil.localStorage.set("dismissedSearchAlerts", {});
    }
}

$(document).on("click", ".usajobs-search-filters__view-results", function (event, opts) {
    closeFilters();

    $('html, body').animate({
        scrollTop: $('.usajobs-site-header').offset().top
    }, 500);
});

// Override of design system - this will move to nav.js if it stays in
$nav.on('nav.additional_locations', function (event, opts) {
    var $target = $search_filter.parent().find(opts.el.attr('data-target'));

    $('html, body').animate({
        scrollTop: $target.offset().top
    }, 500, function () {
        $target.trigger('click');
    });
});

$nav.on('nav.close_refiners', function (event, opts) {
    var $target = $('[data-behavior="search-refiners.toggle"][aria-expanded="true"]');
    $target.trigger('click');

    $('#search-form').submit();
});

var $search_filters_tabs = $('[data-object="search-filters-tabs"]'),
  setupFilters = function () {
      var $filter = $search_filters_tabs.find('[aria-expanded=false]'),
        $target = $search_filters_tabs.closest(".usajobs-search-filters__scroll-container").find('#' + $filter.attr('aria-controls')),
        width = window.innerWidth;

      if (width > 991) {
          $target.attr('aria-hidden', 'true');
      }
  };

$search_filters_tabs.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="search-filters-tabs"]'),
      behavior = $el.attr('data-behavior'),
      $target = $object.parent().find('#' + $el.attr('aria-controls')),
      state = $target.attr('aria-hidden');

    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^search-filters-tabs/)) {
            $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
        }
    });
});

setupFilters();

$search_filters_tabs.on('search-filters-tabs.open', function (event, opts) {
    var $sibling;

    event.preventDefault();

    if (opts.state === "true") {
        // Hide siblings
        $sibling = opts.object.find(opts.el.attr('data-sibling'));

        $sibling.parent().removeClass('is-active');
        $sibling.attr('aria-expanded', 'false');

        opts.target.siblings().attr('aria-hidden', 'true');

        // Show this tab
        opts.el.attr('aria-expanded', 'true');
        opts.el.parent().addClass('is-active');
        opts.target.attr('aria-hidden', 'false');
    } else {
        // Already open, do nothing
    }
});

var $search_refiner = $('[data-object="search-refiner"]');

$search_refiner.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="search-refiner"]'),
      behavior = $el.attr('data-behavior');

    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^search-refiner/)) {
            $el.trigger(action, { el: $el, object: $object });
        }
    });
});

var $search_refiners = $('[data-object="search-refiners"]'),
  setupRefiners = function () {
      var filters = $search_refiners.find('[aria-expanded=false]'),
        $filter,
        $taget;

      $.each(filters, function (idx, filter) {
          $filter = $(filter);
          $target = $search_refiners.find('#' + $filter.attr('aria-controls'));
          target_id = $target.attr('id');

          $target.attr('aria-hidden', true);
      });
  };

$search_refiners.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="search-refiners"]'),
      behavior = $el.attr('data-behavior'),
      $target = $object.find('#' + $el.attr('aria-controls')),
      state = $target.attr('aria-hidden');

    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^search-refiners/)) {
            $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
        }
    });
});

setupRefiners();

$search_refiners.on('search-refiners.toggle', function (event, opts) {
    var $sibling;

    event.preventDefault();

    if (opts.state === "true") {
        // Hide siblings
        $sibling = opts.object.find(opts.el.attr('data-sibling'));

        $sibling.parent().removeClass('is-active');
        $sibling.attr('aria-expanded', 'false');

        opts.target.siblings().attr('aria-hidden', 'true');

        // Show this tab
        opts.el.attr('aria-expanded', 'true');
        opts.el.parent().addClass('is-active');
        opts.target.attr('aria-hidden', 'false');
    } else {
        // Hide this tab
        opts.el.attr('aria-expanded', 'false');
        opts.el.parent().removeClass('is-active');
        opts.target.attr('aria-hidden', 'true');
    }
});


var $search_tab_bar = $('[data-object="search-tab-bar"]'),
    $filters = $('.usajobs-search-filters'),
    $canvas = $('#search-form'),
    $filter_controls = $('#search-tab-bar-filter-controls'),
    $tab_bar_controls = $('#search-tab-bar-controls'),
    hideFiltersOnLoad = function () {
        var width = window.innerWidth;

        if (width < 992) {
            $filters.attr('aria-hidden', true);
        } else {
            $filters.attr('aria-hidden', false);
            $canvas.removeAttr('data-state');
        }
    },
    showFilters = function (opts) {
        $('#search-tab-bar-save').attr("aria-expanded", "false");
        $('#search-save').attr("aria-hidden", "true");
        opts.el.attr('aria-expanded', 'true');
        opts.target.attr('aria-hidden', 'false');
        $canvas.attr('data-state', 'is-hidden');
        // showFilterControls();
    },
    hideFilters = function (opts) {
        opts.el.attr('aria-expanded', 'false');
        opts.target.attr('aria-hidden', 'true');
        $canvas.removeAttr('data-state');
        // hideFilterControls();
    },
    hideFilterControls = function () {
        $filter_controls.attr('aria-hidden', 'true');
        $tab_bar_controls.attr('aria-hidden', 'false');
    },
    showFilterControls = function () {
        $filter_controls.attr('aria-hidden', 'false');
        $tab_bar_controls.attr('aria-hidden', 'true');
    },
    showSaveSearch = function (opts) {
        $('#search-tab-bar-filter').attr("aria-expanded", "false");
        $('#rightrail').attr("aria-hidden", "true");      
        var userObject = Basil.sessionStorage.get("userObject");
        if (userObject && userObject.IsAuthenticated) {
            $("#usajobs-save-search").removeClass("usajobs-hidden");
        } else {
            $('#search-save-n').attr("aria-hidden", "false");
            $("#usajobs-save-search").removeClass("usajobs-hidden");
        }
       
        opts.el.attr('aria-expanded', 'true');
        opts.target.attr('aria-hidden', 'false');
        $body.attr('data-state', 'is-locked');
  },
  hideSaveSearch = function (opts) {
      $('.usajobs-search-save__input').removeClass("usa-input-error").find('#input-error-message').remove();
      $('#input-error-message').html();
      opts.el.attr('aria-expanded', 'false');
      opts.target.attr('aria-hidden', 'true');
      $body.removeAttr('data-state');
  },
  showSort = function (opts) {
      $('#search-tab-bar-filter').attr("aria-expanded", "false");
      $('#rightrail').attr("aria-hidden", "true");
      $('#search-tab-bar-save').attr("aria-expanded", "false");
      $('#search-save').attr("aria-hidden", "true");
      opts.el.attr('aria-expanded', 'true');
      opts.target.attr('aria-hidden', 'false');
      $body.attr('data-state', 'is-locked');
  },
  hideSort = function (opts) {
      opts.el.attr('aria-expanded', 'false');
      opts.target.attr('aria-hidden', 'true');
      $body.removeAttr('data-state');
  };

$search_tab_bar.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="search-tab-bar"]'),
      behavior = $el.attr('data-behavior'),
      $target = $(document).find('#' + $el.attr('aria-controls')),
      state = $target.attr('aria-hidden');

    $el.blur(); // Removes focus
    hideOpenTips();

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^search-tab-bar/)) {
            $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
        }
    });
});

$search_tab_bar.on('search-tab-bar.toggle-filters', function (event, opts) {
    event.preventDefault();

    if (opts.el.attr('aria-expanded') === 'false') {
        showFilters(opts);
    } else {
        hideFilters(opts);
    }
});

$search_tab_bar.on('search-tab-bar.cancel', function (event, opts) {
    event.preventDefault();
    hideFilters(opts);
});

$search_tab_bar.on('search-tab-bar.show-results', function (event, opts) {
    event.preventDefault();
    hideFilters(opts);
    $("html, body").animate({ scrollTop: 0 });
});

document.querySelector('#search-filter-show-results')?.addEventListener('click', evt => {
    evt.preventDefault();
    hideFilters({ el: $('#search-tab-bar-filter'), target: $('#usajobs-search-filters') });
    $("html, body").animate({ scrollTop: 0 });
});

$search_tab_bar.on('search-tab-bar.toggle-save-search', function (event, opts) {
    event.preventDefault();   
    if (opts.el.attr('aria-expanded') === 'false') {
        showSaveSearch(opts);
    } else {
        hideSaveSearch(opts);
    }
});

$search_tab_bar.on('search-tab-bar.toggle-sort', function (event, opts) {
    event.preventDefault();
    if (opts.el.attr('aria-expanded') === 'false') {
        showSort(opts);
    } else {
        hideSort(opts);
    }
});

$(document).ready(function () {
    if ($search_tab_bar !== undefined && $search_tab_bar.length > 0) {
        hideFiltersOnLoad();
    }
});

// Code adopted from http://heydonworks.com/practical_aria_examples/js/a11y.js

initViewToggle = function () {
    var container = '[data-object="search-agency-toggle"]',
      section,
      $section,
      $container = $(container),
      sections = [];

    // The setup
    $container
      .find('[data-toggle="list"]')
      .attr('role', 'tablist');

    $container
      .find('[role="tablist"] li')
      .attr('role', 'presentation')
      .find('a').attr({
          'role': 'tab',
          'tabindex': '-1'
      })
      .each(function () {
          // Make each aria-controls correspond id of targeted section (re href)
          section = $(this).attr('href').substring(1);
          $(this).attr('aria-controls', section);
          sections.push(section);
      });

    // Make the first tab selected by default and allow it focus
    $(container + ' [role="tablist"] li:first-child a').attr({
        'aria-selected': 'true',
        'tabindex': '0'
    });

    // Make each section focusable and give it the tabpanel role
    // Make first child of each panel focusable programmatically
    // Make all but the first section hidden (ARIA state and display CSS)
    $.each(sections, function (idx, section) {
        $section = $('#' + section);

        $section
          .attr('role', 'tabpanel')
          .find('> *:first-child')
          .attr('tabindex', '0');

        if (idx !== 0) {
            $section.attr('aria-hidden', 'true');
        }
    });

    // Change focus between tabs with arrow keys
    $(container + ' [role="tab"]').on('keydown', function (e) {
        // define current, previous and next (possible) tabs
        var $original = $(this),
          $prev = $(this).parents('li').prev().children('[role="tab"]'),
          $next = $(this).parents('li').next().children('[role="tab"]'),
          $target;

        // find the direction (prev or next)
        switch (e.keyCode) {
            case 37:
                $target = $prev;
                break;
            case 39:
                $target = $next;
                break;
            default:
                $target = false;
                break;
        }

        if ($target.length) {
            $original.attr({
                'tabindex': '-1',
                'aria-selected': null
            });
            $target.attr({
                'tabindex': '0',
                'aria-selected': true
            }).focus();
        }

        // Hide panels
        $(container + ' [role="tabpanel"]')
          .attr('aria-hidden', 'true');

        // Show panel which corresponds to target
        $('#' + $(document.activeElement).attr('href').substring(1))
          .attr('aria-hidden', null);
    });

    // Handle click on tab to show + focus tabpanel
    $(container + ' [role="tab"]').on('click', function (e) {
        e.preventDefault();

        // remove focusability [sic] and aria-selected
        $(container + ' [role="tab"]').attr({
            'tabindex': '-1',
            'aria-selected': null
        });

        // replace above on clicked tab
        $(this).attr({
            'aria-selected': true,
            'tabindex': '0'
        });

        // Hide panels
        $(container + ' [role="tabpanel"]').attr('aria-hidden', 'true');

        // show corresponding panel
        $('#' + $(this).attr('href').substring(1))
          .attr('aria-hidden', null);
    });
};

initViewToggle();
$(window).resize(() => throttle(250, function () {
    $(".usajobs-search-tip").removeAttr("style").attr("aria-hidden", true);
}));

$search_filter.on('search-filter.open-tip', function (event, opts) {
    var $content = $search_form.find(opts.el.attr('data-tip-target')),
      state = $content.attr('aria-hidden'),
      checked = opts.el.prop('checked'),
      placeContent = function () {
          if (window.innerWidth < 992) {
              $content.css({
                  'width': '92%',
                  'margin-left': 'auto',
                  'margin-right': 'auto'
              });
          }
          
          $content.position({
              my: 'left top',
              at: 'left bottom',
              of: opts.el.closest("li").find("label"),
              collision: 'fit'
          });

          // The jquery ui position function is not doing what we ask above
          // This adds some space so the thing we are focusing on isn't covered up
          $content.css({
              'margin-top': '2rem'
          });
      };
    
    if ($content.attr("style") === undefined) {
        placeContent();
    }

    checkForDismissedSearchAlerts();

    if (Basil.localStorage.get("dismissedSearchAlerts")[$content.attr("id")] !== true) {
        if (state === 'true' && checked === true) {
            // Show the tip
            $content.fadeIn('fast', function () {
                $content.attr('aria-hidden', 'false');
            });
            hideOpenTips();
            $("#rightrail").one("scroll", function () {
                hideOpenTips();
            });
        } else {
            // Hide the tip
            $content.fadeOut('fast', function () {
                $content.attr('aria-hidden', 'true');
            });
        }
    }
});

var $search_tip = $('[data-object="search-tip"]'),
  $search_form = $("body");

$search_tip.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('.usajobs-search-tip'),
      behavior = $el.attr('data-behavior');

    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^search-tip/)) {
            $el.trigger(action, { el: $el, object: $object });
        }
    });
});

$search_tip.on('search-tip.select-filter', function (event, opts) {
    var $target = $search_form.find(opts.el.attr('data-target'));
    if (!$target.is(":checked")) {
        $target.trigger('click');
    }
});

$search_tip.on('search-tip.close', function (event, opts) {
    opts.object.fadeOut('fast', function () {
        opts.object.attr('aria-hidden', 'true');
    });
});

$(document).on("search-tip.dismiss", "[data-object='search-tip']", function (event, opts) {
    checkForDismissedSearchAlerts();
    var alerts = Basil.localStorage.get("dismissedSearchAlerts");
    alerts[opts.object.attr("id")] = true;
    Basil.localStorage.set("dismissedSearchAlerts", alerts);
});


$(document).on("click", ".usajobs-search-filters__container", function () {
    hideOpenTips();
});

$(document).on("click", ".user-logged-out, .saved-search-sign-in, .usajobs-search-prefs--cta__button", function (e) {
    e.preventDefault();
    var redirectURL = "";
    var searchParameters = window.location.search != "" ? window.location.search.replace(/([?&])(p=\d*)/ig, "$1p=1") + "&auth=True" : "?auth=True";
    redirectURL = window.location.protocol + "//" + window.location.host + "/Account/Challenge/?returnPath=/Search/Results" + searchParameters;
    window.location.href = redirectURL;
});

var $search_prefs = $('[data-object="search-prefs"]');

$search_prefs.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
        $object = $el.closest('[data-object="search-prefs"]'),
        behavior = $el.attr('data-behavior'),
        $target = $object.find('#' + $el.attr('aria-controls')),
        state = $el.attr('data-state');

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^search-prefs/)) {
            $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
        }
    });
});

$search_prefs.on('search-prefs.toggle-cta', function (event, opts) {
    var state = opts.target.attr('aria-hidden');

    opts.target.attr('aria-hidden', state === 'false' ? 'true' : 'false');
});

$(document).on("click", "#profile-no-preferences-dismiss", function () {
    $.post("UpdateLastRelatedUpdate");
});

$(document).on("click", "#profile-outdated-dismiss", function () {
    $.post("UpdateLastRelatedUpdate");
});
